"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var theme_1 = require("../../../mantine-theme/src");
exports.default = react_jss_1.createUseStyles({
    card: function (_a) {
        var theme = _a.theme, radius = _a.radius, padding = _a.padding;
        var spacing = theme_1.getSizeValue({ size: padding, sizes: theme.spacing });
        var borderRadius = theme_1.getSizeValue({ size: radius, sizes: theme.radius });
        return {
            position: 'relative',
            '& [data-mantine-image]': {
                width: "calc(100% + " + spacing * 2 + "px) !important",
                marginLeft: -spacing,
                marginRight: -spacing,
                '&:first-child': {
                    borderTopRightRadius: borderRadius,
                    borderTopLeftRadius: borderRadius,
                    marginBottom: spacing,
                    marginTop: -spacing,
                },
                '&:last-child': {
                    borderBottomRightRadius: borderRadius,
                    borderBottomLeftRadius: borderRadius,
                    marginTop: spacing,
                    marginBottom: -spacing,
                },
                '&:first-child:last-child': {
                    marginTop: -spacing,
                    marginBottom: -spacing,
                },
            },
            '& [data-mantine-hr]': {
                borderTopColor: theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2],
                marginLeft: -spacing,
                marginRight: -spacing,
                marginBottom: spacing / 2,
                marginTop: spacing / 2,
            },
        };
    },
}, { link: true });
